const automationTagsActionType = {
  // automation tags
  FETCH_AUTOMATION_TAGS: "FETCH_AUTOMATION_TAGS",
  FETCH_AUTOMATION_TAGS_SUCCESS: "FETCH_AUTOMATION_TAGS_SUCCESS",
  FETCH_AUTOMATION_TAGS_FAILURE: "FETCH_AUTOMATION_TAGS_FAILURE",
  // create automation tag
  CREATE_AUTOMATION_TAG: "CREATE_AUTOMATION_TAG",
  CREATE_AUTOMATION_TAG_SUCCESS: "CREATE_AUTOMATION_TAG_SUCCESS",
  CREATE_AUTOMATION_TAG_FAILURE: "CREATE_AUTOMATION_TAG_FAILURE",
  // remove automation tag
  DELETE_AUTOMATION_TAG: "DELETE_AUTOMATION_TAG",
  DELETE_AUTOMATION_TAG_SUCCESS: "DELETE_AUTOMATION_TAG_SUCCESS",
  DELETE_AUTOMATION_TAG_FAILURE: "DELETE_AUTOMATION_TAG_FAILURE",
  // search tags
  SEARCH_TAGS: "SEARCH_TAGS",
  SEARCH_TAGS_SUCCESS: "SEARCH_TAGS_SUCCESS",
  SEARCH_TAGS_FAILURE: "SEARCH_TAGS_FAILURE",
};

export default automationTagsActionType;
